<template>
  <v-card align="center" justify="center"  min-width="30vw" outlined>
    <v-card-title>
      <v-list-item>
        <v-list-item-title><h2>{{ this.$tc('title_SeeRequests', pendingMembers.length) }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="overflow-y-auto pa-5" style="max-height: 70vh !important;">
      <v-container fluid>
          <v-row v-bind:key="member.id" v-for="member in pendingMembers">
            <v-col class="d-flex align-center justify-start">
              <v-avatar size="40"><v-img :src="member.user.imageUrl !== null? member.user.imageUrl : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'" contain></v-img></v-avatar>
              <p class="mb-0 ml-3 text-start" style="font-size: 15px; ">{{ member.user.firstName }} {{ member.user.lastName }}</p>
            </v-col>
            <v-col class="d-flex align-center justify-center">
              <v-chip color="var(--v-darkGreen-base)" @click="approveMember(member)">{{ $t('approve') }} <v-icon class="ml-1" x-small>fa-check</v-icon></v-chip>
              <v-chip color="#EF5350" class="ml-2" @click="denyMember(member)">{{ $t('deny') }} <v-icon class="ml-1" x-small>fa-times</v-icon></v-chip>
            </v-col>
          </v-row>
      </v-container>
      <v-btn @click="close">{{ $t('btnClose_SeeRequests') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
export default {
  name: "SeeRequests",
  props: {
    pendingMembers: Array,
  },
  methods: {
    ...mapMutations(['setClubMembers']),
    approveMember(member) {
      Repository.changeClubMemberRol(member.id, 'MEMBER').then((response) => {
        if(response.status < 400) {
          this.pendingMembers.splice(this.pendingMembers.findIndex(item => item.id === member.id), 1);
          Repository.getAllClubMembers(member.club.id).then((secondResponse) => {
            if (secondResponse.status < 400)
              this.setClubMembers(secondResponse.data);
          });

          // Verify if there exists more pending requests
          if(this.pendingMembers.length === 0) this.close();
        }
      });
    },
    ...mapMutations(['setClubMembers']),
    denyMember(member) {
      Repository.denyClubMember(member.id).then((response) => {
        if(response.status < 400) {
          this.pendingMembers.splice(this.pendingMembers.findIndex(item => item.id === member.id), 1);
          Repository.getAllClubMembers(member.club.id).then((secondResponse) => {
            if (secondResponse.status < 400)
              this.setClubMembers(secondResponse.data);
          });

          // Verify if there exists more pending requests
          if(this.pendingMembers.length === 0) this.close();
        }
      });
    },
    close() {
      this.$emit('closeWindow');
    }
  },
}
</script>



<style scoped>

</style>
